import { cropRectToImagePosition } from "../utils";
import { isWhiteBorderProduct } from "../Webshop/providers/PriceListProvider";

export const getProductSizeInPixels = (product) => {
  const { printareasize } = product;

  const widthInMm = parseInt(printareasize[0] / 10);
  const heightInMm = parseInt(printareasize[1] / 10);

  const widthInInches = widthInMm / 25.4;
  const heightInInches = heightInMm / 25.4;

  // We assume 300 dpi?
  const widthInPixels = widthInInches * 300;
  const heightInPixels = heightInInches * 300;

  // Always return biggest number as width:
  if (widthInPixels < heightInPixels) {
    return { width: heightInPixels, height: widthInPixels };
  }

  return { width: widthInPixels, height: heightInPixels };
};

export const imageQualityWarning = (imageAreaPixels, imagePixels) => {
  const sm_printsize10x10pixels = 1452025; // 1205 * 1205;
  const sm_printsize15x15pixels = 3312400; // 1820 * 1820;
  const sm_printsize20x30pixels = 8633994; // 2397 * 3602;
  const sm_printsize50x70pixels = 48816635; // 5905 * 8267;

  const sm_megapixels_0_4 = 360000; // 600*600 pixels
  const sm_megapixels_2 = 2000000;
  const sm_megapixels_5 = 5000000;
  const sm_megapixels_8 = 8000000;
  const sm_megapixels_10 = 10000000;

  // Due to Express-bild selling pictures at 50x70, but only have 8mpix pictures,
  // we assume the quality is good enough, so reduce the original check from
  // 10MP to 8MP
  if (imageAreaPixels > sm_printsize50x70pixels) {
    console.log("Quality check: 50x70, 8MP", imageAreaPixels, imagePixels);
    return imagePixels < sm_megapixels_8;
  } else if (imageAreaPixels > sm_printsize20x30pixels) {
    console.log("Quality check: 20x30, 5MP", imageAreaPixels, imagePixels);
    return imagePixels < sm_megapixels_5;
  } else if (imageAreaPixels > sm_printsize15x15pixels) {
    console.log("Quality check: 15x15, 2MP", imageAreaPixels, imagePixels);
    return imagePixels < sm_megapixels_2;
  }

  console.log("Quality check: < 15x15, 0.4MP", imageAreaPixels, imagePixels);
  return imagePixels < sm_megapixels_0_4;
};

export const getProductOrientationByCropRect = (product, cropRect) => {
  const productSize = getProductSizeInPixels(product);

  // Flip paper if needed:
  const cropRectAngle = Math.atan(cropRect.width / cropRect.height);
  const paperAngle1 = Math.atan(productSize.width / productSize.height);
  const paperAngle2 = Math.atan(productSize.height / productSize.width);

  if (
    Math.abs(cropRectAngle - paperAngle1) >
    Math.abs(cropRectAngle - paperAngle2)
  ) {
    return "portrait";
  }
  return "landscape";
};

export const productCropRectWillHaveWhiteBorders = (
  product,
  cropRect,
  imageSize,
) => {
  // If it's white border, we don't really care for extra white borders?
  if (isWhiteBorderProduct(product)) {
    return;
  }

  const orientation = getProductOrientationByCropRect(product, cropRect);

  let printAreaSize = getProductSizeInPixels(product);
  if (orientation == "portrait") {
    printAreaSize = {
      width: printAreaSize.height,
      height: printAreaSize.width,
    };
  }

  const imagePos = cropRectToImagePosition(
    cropRect,
    imageSize,
    printAreaSize,
    "fit-in",
  );

  if (imagePos.x > 0 || imagePos.y > 0) {
    // 1% is a problem?
    const percent = 1;
    if (
      (imagePos.x * 100) / printAreaSize.width > percent ||
      (imagePos.y * 100) / printAreaSize.height > percent
    ) {
      return true;
    }
  }

  return false;
};

export const isGroupPicture = (image) => {
  return image.keywords.indexOf("group_picture") >= 0;
};

export const isMiniGroupPicture = (image) => {
  return image.keywords.indexOf("mini_group_picture") >= 0;
};

export const isIndividualPicture = (image) => {
  return image.keywords.indexOf("individual_picture") >= 0;
};
